import _extends from "@babel/runtime/helpers/extends";
import { mergeProps } from "@react-aria/utils";
import { deepmerge } from "deepmerge-ts";
import React, { forwardRef, useImperativeHandle, useMemo, useState } from "react";
import { ThemeProvider, useTheme } from "styled-components";
import { Ripple, useRipple } from "../Ripple/Ripple";
import { Addon } from "./Elements/Addon";
import { Container } from "./Elements/Container";
import { HoverAnimation } from "./Elements/HoverAnimation";
import { Label } from "./Elements/Label";
import { Spinner } from "./Elements/Spinner";
const ButtonWithRef = /*#__PURE__*/forwardRef(Button);
export { ButtonWithRef as Button };
function Button(_ref, ref) {
  var _appendedHoverEffect2, _prependedHoverEffect2;
  let {
    addonHoverEffect,
    append,
    appendedHoverEffect,
    as: asProp,
    busy = false,
    children,
    disabled = false,
    labelAs,
    labelProps,
    hoverEffect: hoverEffectProp,
    prepend,
    prependedHoverEffect,
    shape = "normal",
    size: sizeProp,
    theme: customTheme,
    variant: variantProp,
    ...containerProps
  } = _ref;
  const as = disabled ? "button" : asProp;
  if (addonHoverEffect) {
    var _appendedHoverEffect, _prependedHoverEffect;
    appendedHoverEffect = (_appendedHoverEffect = appendedHoverEffect) !== null && _appendedHoverEffect !== void 0 ? _appendedHoverEffect : addonHoverEffect;
    prependedHoverEffect = (_prependedHoverEffect = prependedHoverEffect) !== null && _prependedHoverEffect !== void 0 ? _prependedHoverEffect : addonHoverEffect;
  }
  appendedHoverEffect = (_appendedHoverEffect2 = appendedHoverEffect) !== null && _appendedHoverEffect2 !== void 0 ? _appendedHoverEffect2 : "none";
  prependedHoverEffect = (_prependedHoverEffect2 = prependedHoverEffect) !== null && _prependedHoverEffect2 !== void 0 ? _prependedHoverEffect2 : "none";
  const [containerRef, setContainerRef] = useState(null);
  useImperativeHandle(ref, () => containerRef, [containerRef]);
  const theme = useTheme();
  const {
    components: {
      button: buttonTheme,
      ripple: rippleTheme
    }
  } = theme;
  const hoverEffect = hoverEffectProp !== null && hoverEffectProp !== void 0 ? hoverEffectProp : buttonTheme.defaultProps.hoverEffect;
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : buttonTheme.defaultProps.size;
  const variant = variantProp !== null && variantProp !== void 0 ? variantProp : buttonTheme.defaultProps.variant;
  const currentButtonStyle = useMemo(() => {
    var _buttonTheme$defaultS, _buttonTheme$size$siz, _buttonTheme$size, _buttonTheme$shape$sh, _buttonTheme$shape, _buttonTheme$variant$, _buttonTheme$variant;
    const style = deepmerge((_buttonTheme$defaultS = buttonTheme.defaultStyle) !== null && _buttonTheme$defaultS !== void 0 ? _buttonTheme$defaultS : {}, (_buttonTheme$size$siz = (_buttonTheme$size = buttonTheme.size) === null || _buttonTheme$size === void 0 ? void 0 : _buttonTheme$size[size]) !== null && _buttonTheme$size$siz !== void 0 ? _buttonTheme$size$siz : {}, (_buttonTheme$shape$sh = (_buttonTheme$shape = buttonTheme.shape) === null || _buttonTheme$shape === void 0 ? void 0 : _buttonTheme$shape[shape]) !== null && _buttonTheme$shape$sh !== void 0 ? _buttonTheme$shape$sh : {}, (_buttonTheme$variant$ = (_buttonTheme$variant = buttonTheme.variant) === null || _buttonTheme$variant === void 0 ? void 0 : _buttonTheme$variant[variant]) !== null && _buttonTheme$variant$ !== void 0 ? _buttonTheme$variant$ : {}, customTheme !== null && customTheme !== void 0 ? customTheme : {});
    if (hoverEffect !== "color") {
      style.hover = undefined;
    }
    return style;
  }, [buttonTheme, customTheme && JSON.stringify(customTheme), hoverEffect, shape, size, variant]);
  const currentTheme = useMemo(() => deepmerge(theme, {
    components: {
      button: {
        current: currentButtonStyle
      },
      ripple: deepmerge(rippleTheme, currentButtonStyle.ripple)
    }
  }), [currentButtonStyle, rippleTheme, theme]);
  const {
    rippleProps,
    triggerProps
  } = useRipple({
    trigger: containerRef
  });
  const contentOpacity = busy ? "0" : "1";
  const withAddon = Boolean(prepend || append);
  const addonHoverEffectDelay = hoverEffect.startsWith("anim-") ? "0.75s" : undefined;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: currentTheme
  }, /*#__PURE__*/React.createElement(Container, _extends({
    $withAddon: withAddon,
    as: as,
    "data-busy": busy || undefined,
    disabled: disabled || busy || undefined
  }, mergeProps(containerProps, triggerProps), {
    ref: setContainerRef
  }), !disabled && rippleProps && /*#__PURE__*/React.createElement(Ripple, rippleProps), busy && /*#__PURE__*/React.createElement(Spinner, null), /*#__PURE__*/React.createElement(HoverAnimation, {
    variant: hoverEffect
  }, prepend && /*#__PURE__*/React.createElement(Addon, {
    $opacity: contentOpacity,
    hoverEffect: prependedHoverEffect,
    hoverEffectDelay: addonHoverEffectDelay
  }, prepend, " "), /*#__PURE__*/React.createElement(Label, _extends({
    $opacity: contentOpacity,
    as: labelAs,
    withAddon: withAddon
  }, labelProps), children), append && /*#__PURE__*/React.createElement(Addon, {
    $opacity: contentOpacity,
    hoverEffect: appendedHoverEffect,
    hoverEffectDelay: addonHoverEffectDelay
  }, " ", append))));
}
//# sourceMappingURL=Button.js.map